import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  shouldRefreshCache: false,
}

/**
 * keepalive 的缓存保存，用于判断是否需要清掉某个页面缓存
 * 仅作用于<KeepAliveRoute> 包裹的页面，触发逻辑为保存/或者取消
 */
const cacheSlice = createSlice({
  name: 'cacheSlice',
  initialState: initialState,
  reducers: {
    setShouldRefreshCache(state, action) {
      return {
        ...state,
        shouldRefreshCache: action.payload,
      }
    },
  },
})

export const { setShouldRefreshCache } = cacheSlice.actions
export default cacheSlice.reducer
